import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import { GraduationApi, GraduateStaffDetail, errorMessage } from '../services/GraduationApi';
import GraduateApplicationNotes from './GraduateApplicationNotes';
import { containModalFocus } from './modalFocus';

export default function GraduateApplicationNotesDialog({ applicationId, studentName, onClose }: {
  applicationId: number; studentName: string; onClose: () => void;
}) {
  const [detail, setDetail] = useState<GraduateStaffDetail | null>(null);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const controller = new AbortController(); setError('');
    GraduationApi.graduateStaffDetail(applicationId,controller.signal).then(result => {
      if (!controller.signal.aborted) setDetail(result);
    }).catch(e => { if (!controller.signal.aborted && !axios.isCancel(e)) setError(errorMessage(e)); });
    return () => controller.abort();
  }, [applicationId, revision]);
  return <Modal show onHide={() => { if (!busy) onClose(); }} onKeyDown={containModalFocus} size="lg" aria-labelledby="graduate-notes-dialog-heading">
    <Modal.Header closeButton={!busy}><Modal.Title id="graduate-notes-dialog-heading">Notes for {studentName}</Modal.Title></Modal.Header>
    <Modal.Body>
      <p className="text-secondary">Graduate application #{applicationId}</p>
      {error && <Alert variant="danger" role="alert">{error} <Button variant="outline-danger" size="sm" onClick={() => setRevision(value => value+1)}>Reload notes</Button></Alert>}
      {!detail && !error && <p role="status">Loading notes…</p>}
      {detail && <GraduateApplicationNotes detail={detail} canEdit isAdministrator
        onBusyChange={setBusy} onRefresh={() => setRevision(value => value+1)} />}
    </Modal.Body>
    <Modal.Footer><Button variant="outline-secondary" disabled={busy} onClick={onClose}>Close notes</Button></Modal.Footer>
  </Modal>;
}
